import { getEcho } from "@/helper/echo";

let channel = null;
let firmId = null;
let unwatchFirm = null;

export const isSupportedSupplierDocumentEvent = event =>
  event?.document_type === "delivery_note"
  && ["supplier_order", "supplier_receipt"].includes(event?.document_context);

const leaveCurrentChannel = () => {
  const Echo = getEcho();

  if (channel) {
    channel.stopListening(".supplier-document.processed");
  }

  if (Echo && firmId) {
    Echo.leave(`supplier-documents.firm.${firmId}`);
  }

  channel = null;
  firmId = null;
};

const subscribe = (nextFirmId, app) => {
  if (!nextFirmId || Number(nextFirmId) === Number(firmId)) {
    return;
  }

  leaveCurrentChannel();
  const Echo = getEcho();
  if (!Echo) return;

  firmId = nextFirmId;
  channel = Echo.private(`supplier-documents.firm.${nextFirmId}`);

  channel.listen(".supplier-document.processed", event => {
    if (!isSupportedSupplierDocumentEvent(event)) {
      return;
    }

    const isSharedReceipt = event.document_context === "supplier_receipt";
    if (event.status === "ready") {
      app.$toast.success(app.$t(isSharedReceipt ? "order.supplier_document_ready" : "order.delivery_note_ready"));
    } else if (event.status === "failed") {
      app.$toast.error(event.error_message || app.$t(isSharedReceipt ? "order.supplier_document_failed" : "order.delivery_note_failed"));
    }

    app.$root.$emit("supplier-document-processed", event);
  });

  channel.error(error => {
    console.error("[Supplier Documents] Channel subscription error:", error);
  });
};

export const initializeSupplierDocumentRealtime = app => {
  if (unwatchFirm) {
    return;
  }

  unwatchFirm = app.$store.watch(
    state => state.selectedFirm?.id,
    nextFirmId => subscribe(nextFirmId, app),
    { immediate: true }
  );
};

export const disconnectSupplierDocumentRealtime = () => {
  if (unwatchFirm) {
    unwatchFirm();
    unwatchFirm = null;
  }

  leaveCurrentChannel();
};

export default {
  initializeSupplierDocumentRealtime,
  disconnectSupplierDocumentRealtime,
};
